var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_238_15052)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21893 10.7803C6.07882 10.6386 6.00024 10.4474 6.00024 10.2482C6.00024 10.0489 6.07882 9.85771 6.21893 9.71604L8.42318 7.49229C8.58668 7.33104 8.79818 7.25079 9.00743 7.25079C9.21668 7.25079 9.42443 7.33104 9.58418 7.49229L11.7817 9.70854C11.9216 9.85031 12.0001 10.0415 12.0001 10.2407C12.0001 10.4399 11.9216 10.631 11.7817 10.7728C11.7128 10.8427 11.6307 10.8982 11.5402 10.9361C11.4497 10.9739 11.3526 10.9935 11.2544 10.9935C11.1563 10.9935 11.0592 10.9739 10.9686 10.9361C10.8781 10.8982 10.7961 10.8427 10.7272 10.7728L9.00368 9.03504L7.27343 10.7803C7.2044 10.8499 7.12227 10.9052 7.03178 10.9429C6.94128 10.9806 6.84422 11 6.74618 11C6.64814 11 6.55108 10.9806 6.46058 10.9429C6.37009 10.9052 6.28796 10.8499 6.21893 10.7803Z",
    fill: "#44546F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 10.5C2 13.7998 2 15.4497 3.0248 16.4752C4.051 17.5 5.7002 17.5 9 17.5C12.2998 17.5 13.9497 17.5 14.9745 16.4752C16 15.449 16 13.7998 16 10.5C16 7.2002 16 5.5503 14.9745 4.5255C13.9504 3.5 12.2998 3.5 9 3.5C5.7002 3.5 4.0503 3.5 3.0248 4.5255C2 5.5496 2 7.2002 2 10.5Z",
    fill: "#006EC2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_238_15052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 18.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckin);
export default __webpack_public_path__ + "static/media/checkin.2d601e9201b54682b1bdadc6b0b1a60f.svg";
export { ForwardRef as ReactComponent };